'use client';

import { useTranslations } from 'next-intl';
import { Image } from 'components/image';
import cx from 'classnames';
import styles from './pdp-selected-equipment.module.scss';
import { camelCase, startCase } from 'lodash';
import { Conditional, TextLink } from '@cat-ecom/pcc-components';
import {
  CatHeading,
  CatButton,
  CatIconSwap
} from 'components/blocks-components';
import { replaceTokensWithComponents } from '@cat-ecom/common/utils/stringUtils';
import { useMyEquipmentDrawer } from 'components/my-equipment/my-equipment-drawer-context';

const PdpSelectedEquipment = ({ selectedEquipmentInfo, factoryFitContent }) => {
  const t = useTranslations();
  const equipmentName = `${selectedEquipmentInfo?.model} ${startCase(
    camelCase(selectedEquipmentInfo?.productFamily)
  )}`;
  const {
    editEquipmentDrawer: { openDrawer: openEditDrawer },
    selectEquipmentDrawer: { openDrawer: handleOpenSelectEquipmentDrawer }
  } = useMyEquipmentDrawer();
  const imgURL = selectedEquipmentInfo?.imageURL + '?wid=64&hei=64&fmt=webp';

  const selectedEquipmentImage = (
    <Image
      src={imgURL}
      width={64}
      height={64}
      loading="lazy"
      alt={equipmentName}
      className={cx('me-2', styles['selected-equipment-wrapper__image'])}
      unoptimized
    />
  );
  const changeButton = (
    <CatButton
      variant="ghost"
      className={styles['selected-equipment__change-button']}
      onClick={handleOpenSelectEquipmentDrawer}
    >
      <CatIconSwap slot="before" size="sm" />
      {t('CHANGE')}
    </CatButton>
  );
  const addSerialLink = replaceTokensWithComponents(
    t('MEQ_TO_GET_AN_EXACT_FIT', { '0': '{0}' }),
    <TextLink
      className="text-decoration-underline"
      label={t('MEQ_ADD_SERIAL_NUMBER')}
      onClick={openEditDrawer}
    />
  );
  const addSerialText = (
    <CatHeading
      variant="footnote"
      className={styles['selected-equipment-wrapper__footnote']}
    >
      {addSerialLink}
    </CatHeading>
  );
  return (
    <div className="d-flex flex-column">
      <div className="d-flex flex-row d-md-none d-lg-flex">
        {selectedEquipmentImage}
        <div
          className={cx(
            'd-flex flex-column ms-1 w-100',
            styles['selected-equipment__name-container']
          )}
        >
          <div
            className={cx(
              styles['selected-equipment__name-container--mobile'],
              'd-flex d-flex align-items-start align-items-center justify-content-between w-100'
            )}
          >
            <h4
              className={cx(
                styles['selected-equipment__equipment-name'],
                'cat-u-theme-typography-title-sm mb-0'
              )}
            >
              {selectedEquipmentInfo?.assetId
                ? selectedEquipmentInfo?.assetId
                : equipmentName}
            </h4>
            {changeButton}
          </div>
          <Conditional test={!!selectedEquipmentInfo?.assetId}>
            <CatHeading
              level="h4"
              className={cx(styles['selected-equipment__footnote'])}
              variant="footnote"
            >
              {equipmentName}
            </CatHeading>
          </Conditional>
          <Conditional test={!!selectedEquipmentInfo?.serialNumber}>
            <CatHeading
              level="h4"
              className={cx(styles['selected-equipment__footnote'])}
              variant="footnote"
            >
              {selectedEquipmentInfo?.serialNumber}
            </CatHeading>
          </Conditional>
          <Conditional test={!selectedEquipmentInfo?.serialNumber}>
            {addSerialText}
          </Conditional>
        </div>
      </div>
      {factoryFitContent}
    </div>
  );
};
export default PdpSelectedEquipment;
